import IssueApi from '@/fetch/bussiness/issue';
import { HttpStatusCode } from '@/fetch/core/constant';
import { showMsg } from '@/utils/util';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Row, Col } from 'antd';
import './index.scss';
import { IssueStatus } from '@/utils/type';
import { RootState } from '@/redux/store';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
  sendGlobalEvent,
} from '@/utils/emit';
const fetchApi = new IssueApi();
interface Props {
  vehicleName: string;
  open: boolean;
  setOpen: AnyFunc;
  LC_BUTTON_L3?: boolean;
  issueNumber: string | undefined;
  issueStatus: IssueStatus;
}
const DiscardIssueModal = (props: Props) => {
  const { vehicleName, open, setOpen, LC_BUTTON_L3, issueNumber, issueStatus } =
    props;
  const { list } = useSelector((state: RootState) => state.issue);
  const keyboardUsed = useRef<boolean>(false);
  const confirmDiscard = async (
    issueNumber: string,
    acceptNewIssue: boolean
  ) => {
    try {
      const res = await fetchApi.discardIssue({ issueNumber, acceptNewIssue });
      if (res.code === HttpStatusCode.Success) {
        showMsg({ msg: '抛单成功!', type: 'success' });
      } else {
        showMsg({ msg: res.message, type: 'error' });
      }
      setOpen(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!issueNumber) {
      return;
    }
    if (LC_BUTTON_L3) {
      if (keyboardUsed.current == false) {
        keyboardUsed.current = true;
        setOpen(true);
        sendGlobalEvent('CLOSE_OTHER_MODAL', 'DiscardIssueModal');
      } else {
        keyboardUsed.current = false;
        confirmDiscard(issueNumber!, true);
      }
    }
  }, [LC_BUTTON_L3, issueNumber]);

  useEffect(() => {
    const cb = (modalName: string) => {
      if (modalName === 'DiscardIssueModal') {
        return;
      }
      keyboardUsed.current = false;
      setOpen(false);
    };
    addGlobalEventListener('CLOSE_OTHER_MODAL', cb);
    return () => {
      removeGlobalEventListener('CLOSE_OTHER_MODAL', cb);
    };
  }, []);
  return (
    <>
      <Modal
        width={1000}
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        centered
        destroyOnClose
        footer={
          <>
            <div className="footer" style={{ justifyContent: 'flex-end' }}>
              <div className="operate">
                <Button
                  onClick={() => {
                    setOpen(false);
                    keyboardUsed.current == false;
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  type={'primary'}
                  style={{
                    height: '44px',
                    fontSize: '24px',
                  }}
                  onClick={() => {
                    confirmDiscard(issueNumber!, true);
                  }}
                >
                  确认抛单
                </Button>
                {list?.find(
                  (item: any) => item.issueStatus === IssueStatus.ON_HOLD
                ) &&
                  issueStatus != IssueStatus.ON_HOLD && (
                    <Button
                      style={{
                        marginLeft: '12px',
                        height: '44px',
                        fontSize: '24px',
                      }}
                      type={'primary'}
                      onClick={() => {
                        confirmDiscard(issueNumber!, false);
                      }}
                    >
                      确定抛单并受理挂起工单
                    </Button>
                  )}
              </div>
            </div>
          </>
        }
      >
        <>
          <div className="content-container" style={{ fontSize: '24px' }}>
            <Row justify={'start'} align={'middle'}>
              <Col>
                <img
                  width={36}
                  height={36}
                  style={{ marginRight: '6px' }}
                  src={require('@/assets/images/cockpit/warning_icon.png')}
                ></img>
              </Col>
              <Col style={{ color: '#fff', fontSize: '24px' }}>
                确认是否抛单？
              </Col>
            </Row>
            <Row>
              <Col
                style={{
                  color: '#868D9F',
                  paddingLeft: '48px',
                  marginBottom: '54px',
                  fontSize: '24px',
                }}
              >
                工单将抛至监控池，仅监控端座席能受理此单
              </Col>
            </Row>
          </div>
        </>
      </Modal>
    </>
  );
};
export default React.memo(DiscardIssueModal);
